import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import { Family } from "interfaces/models/family";
import { axiosECS } from "services/baseAxios";

const path = PATH_API.FAMILY;

export const getFamilyList = async (
  shouldCache = false
): Promise<ApiResponse<Family[]>> => {
  return { data: [] };
};

export const createFamily = async (
  family: Family
): Promise<ApiResponse<Family>> => {
  return axiosECS.post(path, family);
};
export const updateFamily = async (
  family: Family
): Promise<ApiResponse<Family>> => {
  return axiosECS.patch(path, family);
};

export const deleteFamilyList = async (
  ids: string[]
): Promise<ApiResponse<any[]>> => {
  return axiosECS.delete(path, { data: { ids } });
};
